var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlowerTulip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.914 336.875C502.038 435 405.648 512 288.13 512H223.87C106.352 512 9.962 435 0.086 336.875C-0.914 327.75 6.962 320 16.088 320H63.346C126.355 320 183.239 342.25 223.995 377.875V256C153.234 256 95.976 198.75 95.976 128V32L175.988 80L257.125 0L336.012 80L416.024 32V128C416.024 198.75 358.766 256 288.005 256V377.875C328.761 342.25 385.645 320 448.654 320H495.912C505.038 320 512.914 327.75 511.914 336.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerTulip);
export default __webpack_public_path__ + "static/media/flower-tulip.ab7c39140c55f396ecea81bba8ddeff2.svg";
export { ForwardRef as ReactComponent };